import React from "react";
import "../../assets/css/Useraccount.css";
import moment from "moment";

const formatAmount = (value) => {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return "0.00";
  }

  return amount.toFixed(2);
};

const formatInvoiceDateTime = (value) => {
  const dateTime = moment(value);

  if (!value || !dateTime.isValid()) {
    return "-";
  }

  return dateTime
    .utcOffset(330)
    .format("DD MMM YYYY, hh:mm A");
};

const Invoices = ({ invoice }) => {
  if (!invoice) {
    return <p className="text-center">No invoice selected</p>;
  }

  const {
    Inv_no,
    issued_at,
    final_price,
    monthly_price,
    tax_price,

    tax_type,
    gst_percentage,

    cgst_percentage,
    cgst_amount,

    sgst_percentage,
    sgst_amount,

    igst_percentage,
    igst_amount,

    payment_status,
    razorpay_payment_id,
    payment_method,
    payment_gateway,
    bank_reference_no,

    email,
    phone,
    address1,
    address2,
    city,
    state,
    country,
    zipcode,
    gst_no,

    sub_name,
    credits,
    plan_type,
    subscription_start_date,
    subscription_renewal_date,
    customer,
  } = invoice;

  const { C_fname, C_lname } = customer || {};

  const normalizedTaxType = String(
    tax_type || ""
  ).toUpperCase();

  const baseAmount = formatAmount(
    monthly_price
  );

  const totalAmount = formatAmount(
    final_price
  );

  const isSubscriptionInvoice =
    String(plan_type || "").toUpperCase() !==
      "ONE_TIME" &&
    String(sub_name || "").toLowerCase() !==
      "coin purchase";

  const renderTaxRows = () => {
    if (normalizedTaxType === "CGST_SGST") {
      return (
        <>
          <tr>
            <td style={summaryLabelStyle}>
              CGST ({formatAmount(cgst_percentage)}%)
            </td>

            <td
              align="right"
              style={summaryValueStyle}
            >
              {formatAmount(cgst_amount)} INR
            </td>
          </tr>

          <tr>
            <td style={summaryLabelStyle}>
              SGST ({formatAmount(sgst_percentage)}%)
            </td>

            <td
              align="right"
              style={summaryValueStyle}
            >
              {formatAmount(sgst_amount)} INR
            </td>
          </tr>
        </>
      );
    }

    if (normalizedTaxType === "IGST") {
      return (
        <tr>
          <td style={summaryLabelStyle}>
            IGST ({formatAmount(igst_percentage)}%)
          </td>

          <td
            align="right"
            style={summaryValueStyle}
          >
            {formatAmount(igst_amount)} INR
          </td>
        </tr>
      );
    }

    return (
      <tr>
        <td
          colSpan={2}
          style={{
            padding: "12px 0",
            color: "#d5d5d5",
            fontSize: "13px",
            lineHeight: "19px",
            borderBottom: "1px solid #2c2c2c",
          }}
        >
          No Indian GST has been charged. The customer is
          responsible for paying any applicable taxes,
          duties, or levies in their own country.
        </td>
      </tr>
    );
  };

  return (
    <div
      style={{
        overflowY: "auto",
        height: "100%",
        backgroundImage:
          "url(https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/inv_logo_assets/BG.png)",
        backgroundSize: "contain",
        backgroundPosition: "top right",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#000000",
      }}
    >
      <table
        width="100%"
        cellPadding="0"
        cellSpacing="0"
        style={{
          fontFamily: "Arial, sans-serif",
          color: "#333",
          borderCollapse: "collapse",
          background: "transparent",
          border: "1px dashed #4f4f4f",
        }}
      >
        <tbody>
          {/* HEADER */}
          <tr>
            <td
              style={{
                padding: "30px",
                width: "50%",
              }}
            >
              <img
                src="https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/inv_logo_assets/Group.png"
                style={{
                  height: "60px",
                  objectFit: "contain",
                }}
                alt="Shaadi Material"
              />

              <div
                style={{
                  fontSize: "15px",
                  lineHeight: "20px",
                  marginTop: "15px",
                  color: "#d5d5d5",
                  letterSpacing: "1px",
                }}
              >
                Shaadimaterial
                <br />
                193/1, 2nd Floor, MG Road<br />
                Kolkata 700007, WB, India<br />
                Email: contact@shaadimaterial.com<br />
                GSTIN : 19CRHPM0854N1Z7
              </div>
            </td>

            <td
              style={{
                padding: "30px",
                verticalAlign: "top",
                width: "50%",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  marginTop: "15px",
                  color: "#d5d5d5",
                  letterSpacing: "1px",
                  fontWeight: 700,
                }}
              >
                TAX INVOICE
              </div>

              <table
                width="100%"
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  marginTop: "15px",
                  color: "#d5d5d5",
                  letterSpacing: "1px",
                }}
              >
                <tbody>
                  <tr>
                    <td
                      align="left"
                      colSpan={2}
                      style={{
                        paddingBottom: "10px",
                        fontWeight: 600,
                        fontSize: "17px",
                      }}
                    >
                      {Inv_no || "-"}
                    </td>
                  </tr>

                  <tr>
                    <td>Invoice Date</td>
                    <td align="right">
                      {issued_at
                        ? moment(issued_at).format(
                          "DD MMM YYYY"
                        )
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <td>Invoice Amount</td>
                    <td align="right">
                      {totalAmount} INR
                    </td>
                  </tr>

                  <tr>
                    <td
                      colSpan={2}
                      style={{
                        color: "#16a34a",
                        fontWeight: 700,
                        paddingTop: "8px",
                      }}
                    >
                      {String(
                        payment_status || "Pending"
                      ).toUpperCase()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          {/* BILL TO */}
          <tr>
            <td
              style={{
                padding: "30px",
                borderTop: "1px solid #2c2c2c",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 700,
                  marginBottom: "8px",
                  color: "#ffadd8",
                  letterSpacing: "1px",
                }}
              >
                BILLED TO
              </div>

              <div
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  marginTop: "15px",
                  color: "#d5d5d5",
                  letterSpacing: "1px",
                }}
              >
                {[C_fname, C_lname]
                  .filter(Boolean)
                  .join(" ") || "-"}
                <br />

                {phone || "-"}
                <br />

                {[address1, address2]
                  .filter(Boolean)
                  .join(", ")}
                <br />

                {[city, state, zipcode]
                  .filter(Boolean)
                  .join(", ")}
                <br />

                {country || "-"}
                <br />

                {email || "-"}
                <br />

                {gst_no && <>GSTIN: {gst_no}</>}
              </div>
            </td>

            <td
              style={{
                padding: "30px",
                borderTop: "1px solid #2c2c2c",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 700,
                  marginBottom: "8px",
                  color: "#ffadd8",
                  letterSpacing: "1px",
                }}
              >
                DESCRIPTION
              </div>

              <div
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  marginTop: "15px",
                  color: "#d5d5d5",
                  letterSpacing: "1px",
                }}
              >
                ID: {sub_name || "-"}
                <br />

                Type: {plan_type || "-"}
                <br />

                Credits: {credits ?? "-"}
                <br />

                Payment ID: {razorpay_payment_id || "-"}
                <br />

                Payment Method: {payment_method || "-"}
                <br />

                Payment Gateway:{" "}
                {payment_gateway || "Razorpay"}
                <br />

                Bank Reference:{" "}
                {bank_reference_no || "-"}
              </div>
            </td>
          </tr>

          {/* TABLE HEADER */}
          <tr>
            <td
              colSpan={2}
              style={{
                padding: "20px 30px",
                borderTop: "1px solid #2c2c2c",
              }}
            >
              <table
                width="100%"
                style={{
                  borderCollapse: "collapse",
                }}
              >
                <tbody>
                  <tr
                    style={{
                      color: "#ffadd8",
                      background: "#ffadd842",
                      border: "1px solid #8b5b74",
                    }}
                  >
                    <td style={{ padding: "5px" }}>
                      Description
                    </td>
                    <td
                      align="center"
                      style={{
                        padding: "5px",
                        width: "80px",
                      }}
                    >
                      SAC
                    </td>

                    <td
                      align="right"
                      style={{
                        padding: "5px",
                        width: "80px",
                      }}
                    >
                      Units
                    </td>

                    <td
                      align="right"
                      style={{
                        padding: "5px",
                        width: "200px",
                      }}
                    >
                      Amount (INR)
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          {/* ITEM */}
          <tr>
            <td
              colSpan={2}
              style={{
                padding: "0 30px 10px",
              }}
            >
              <table
                width="100%"
                style={{
                  fontSize: "16px",
                  borderCollapse: "collapse",
                }}
              >
                <tbody>
                  <tr>
                    <td style={itemCellStyle}>
                      <strong
                        style={{
                          color: "#ffadd8",
                        }}
                      >
                        {sub_name || "Purchase"}
                      </strong>
                    </td>
                    <td
                      align="center"
                      style={{
                        ...itemCellStyle,
                        color: "#ffadd8",
                        fontWeight: 700,
                        width: "80px",
                      }}
                    >
                      998314
                    </td>

                    <td
                      align="right"
                      style={{
                        ...itemCellStyle,
                        color: "#ffadd8",
                        fontWeight: 700,
                        width: "80px",
                      }}
                    >
                      1
                    </td>

                    <td
                      align="right"
                      style={{
                        ...itemCellStyle,
                        color: "#ffadd8",
                        fontWeight: 700,
                        width: "200px",
                      }}
                    >
                      {baseAmount} INR
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          {/* TOTAL */}
          <tr>
            <td
              colSpan={2}
              style={{
                padding: "10px 30px 30px",
              }}
            >
              <table
                width="100%"
                style={{
                  fontSize: "13px",
                }}
              >
                <tbody>
                  <tr>
                    <td />

                    <td width="280">
                      <table
                        width="100%"
                        style={{
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={summaryLabelStyle}>
                              Base Amount
                            </td>

                            <td
                              align="right"
                              style={summaryValueStyle}
                            >
                              {baseAmount} INR
                            </td>
                          </tr>

                          {renderTaxRows()}

                          {Number(tax_price) > 0 && (
                            <tr>
                              <td style={summaryLabelStyle}>
                                Total Tax
                                {Number(gst_percentage) >
                                  0 &&
                                  ` (${formatAmount(
                                    gst_percentage
                                  )}%)`}
                              </td>

                              <td
                                align="right"
                                style={summaryValueStyle}
                              >
                                {formatAmount(tax_price)} INR
                              </td>
                            </tr>
                          )}

                          <tr>
                            <td style={totalLabelStyle}>
                              <strong>Total</strong>
                            </td>

                            <td
                              align="right"
                              style={totalValueStyle}
                            >
                              <strong>
                                {totalAmount} INR
                              </strong>
                            </td>
                          </tr>

                          <tr>
                            <td style={summaryLabelStyle}>
                              Payments
                            </td>

                            <td
                              align="right"
                              style={summaryValueStyle}
                            >
                              {totalAmount} INR
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          {isSubscriptionInvoice && (
            <tr>
              <td
                colSpan={2}
                style={{
                  padding: "0 30px 24px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: 700,
                    marginBottom: "8px",
                    color: "#ffadd8",
                    letterSpacing: "1px",
                  }}
                >
                  SUBSCRIPTION PERIOD
                </div>

                <div
                  style={{
                    borderTop: "1px solid #2c2c2c",
                    borderBottom: "1px solid #2c2c2c",
                    padding: "14px 0",
                    color: "#d5d5d5",
                    fontSize: "14px",
                    lineHeight: "22px",
                    letterSpacing: "1px",
                  }}
                >
                  Your subscription started on{" "}
                  <strong style={{ color: "#ffadd8" }}>
                    {formatInvoiceDateTime(
                      subscription_start_date
                    )}
                  </strong>
                  <br />
                  and will be renewed at{" "}
                  <strong style={{ color: "#ffadd8" }}>
                    {formatInvoiceDateTime(
                      subscription_renewal_date
                    )}
                  </strong>
                </div>
              </td>
            </tr>
          )}

          {/* FOOTER */}
          <tr>
            <td
              colSpan={2}
              align="center"
              style={{
                padding: "25px",
                fontSize: "16px",
                fontWeight: 400,
                color: "#d5d5d5",
                letterSpacing: "1px",
              }}
            >
              Thank you for trusting us <br />
              contact@shaadimaterial.com || © {new Date().getFullYear()} The Graphē. All rights reserved.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const itemCellStyle = {
  padding: "8px 5px",
  borderBottom: "1px solid #2c2c2c",
};

const summaryLabelStyle = {
  padding: "7px 0",
  fontSize: "16px",
  color: "#d5d5d5",
  fontWeight: 700,
  borderBottom: "1px solid #2c2c2c",
};

const summaryValueStyle = {
  padding: "7px 0",
  fontSize: "16px",
  color: "#d5d5d5",
  fontWeight: 700,
  borderBottom: "1px solid #2c2c2c",
  whiteSpace: "nowrap",
};

const totalLabelStyle = {
  padding: "9px 0",
  fontSize: "16px",
  color: "#ffadd8",
  fontWeight: 700,
  borderBottom: "1px solid #2c2c2c",
};

const totalValueStyle = {
  padding: "9px 0",
  fontSize: "20px",
  color: "#ffadd8",
  fontWeight: 700,
  borderBottom: "1px solid #2c2c2c",
  whiteSpace: "nowrap",
};

export default Invoices;
